import _ from "lodash"

export function CalcSign(post_data = {}, post_params = {}){
	// timestamp
	let timestamp = Math.round(new Date() / 1000);
	// sort
	let sign_data = _.merge(post_data, post_params, {timestamp});
	let sign_data_keys = _.keys(sign_data);
	let sort_data = sign_data_keys.sort();
	let sign_sort_data = {};
	_.each(sort_data, (item)=>{
		sign_sort_data[item] = sign_data[item];
	});

	// sign
	let sign = window.crypto.Sign(JSON.stringify(sign_sort_data));
	return {sign, timestamp};
}

export function ResponseCode(error){
	if(error.response.status === 401){
		$vue.$store.commit('RemoveUser');
		$vue.$Notice.error({
			title: '登录状态已过期',
			desc: '已跳转至登录页面，请重新登录'
		});
		$vue.$router.push({name: 'Login'});
	}else if(error.response.status === 403){
		$vue.$Notice.error({
			title: '访问被拒绝',
			desc: error.response.data.message,
		});
	}else if(error.response.status === 422){
		$vue.$Notice.warning({
			title: '提交参数不正确',
			desc: error.response.data.message,
		});
	}else if(error.response.status === 429){
		let second = error.response.data['retry-after'];
		$vue.$Notice.warning({
			title: `您提交的太过频繁，请在${second}秒后再试`,
		});
	}
}